import React from 'react';
import styles from './LoadingSkeleton.module.css';

function SkeletonCard() {
  return (
    <div className={styles.card}>
      <div className={styles.thumbnail} />
      <div className={styles.content}>
        <div className={styles.titleLine} />
        <div className={styles.titleLineShort} />
        <div className={styles.badgeRow}>
          <div className={styles.badge} />
          <div className={styles.badge} />
        </div>
        <div className={styles.timer} />
        <div className={styles.button} />
      </div>
    </div>
  );
}

function LoadingSkeleton() {
  return (
    <div className={styles.grid}>
      {Array.from({ length: 8 }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}

export default LoadingSkeleton;
